import { getClassMoment } from "./time.js";

export function getRoutineLogStatus(routine, log) {
  if (log?.classStatus === "suspended") return "Suspended";
  if (log?.actualIn && log?.actualOut) return "Completed";
  if (log?.actualIn && !log?.actualOut) return "Pending OUT";
  const moment = getClassMoment(routine);
  if (moment === "running") return "Running Now";
  if (moment === "upcoming") return "Not Started";
  return "Not Marked";
}

export function statusVariant(status = "") {
  const normalized = status.toLowerCase();
  if (normalized.includes("late") || normalized.includes("pending")) return "warning";
  if (normalized.includes("early")) return "purple";
  if (normalized.includes("complete") || normalized.includes("on time")) return "success";
  if (normalized.includes("suspend")) return "danger";
  if (normalized.includes("running")) return "info";
  return "neutral";
}

export const SUSPENSION_REASONS = [
  "Class suspended due to teacher absent",
  "Class suspended due to exam",
  "Class suspended due to technical issue",
  "Class suspended due to other issue"
];
